/* ============================================================================
   SNAPBANDS — Cart custom behaviour  (assets/cart-custom.js)
   ----------------------------------------------------------------------------
   Drives the unlock-rewards bar. Pure vanilla JS, no jQuery.
   Hooks into Pipeline's own cart system:
     • document 'theme:cart:change'  -> fires on every add/remove/qty change,
                                         carries e.detail.cart (the live cart)
     • 'theme:drawer:open'           -> re-sync when the drawer is opened
     • on load                       -> initial /cart.js fetch so the bar is
                                         correct before the first interaction
   ============================================================================ */
(function () {
  'use strict';

  var SEL = {
    wrap:   '[data-sb-rewards]',
    msg:    '[data-sb-rewards-msg]',
    fill:   '[data-sb-rewards-fill]',
    config: '[data-sb-rewards-config]'
  };

  function readConfig(wrap) {
    var node = wrap.querySelector(SEL.config);
    var fallback = {
      target_qty: 4,
      pre: 'Add {remaining} more to unlock your reward',
      almost: 'Almost there — add {remaining} more!',
      unlocked: '🎉 Reward unlocked!'
    };
    if (!node) return fallback;
    try {
      var cfg = JSON.parse(node.textContent.trim());
      cfg.target_qty = parseInt(cfg.target_qty, 10) || fallback.target_qty;
      return cfg;
    } catch (e) {
      return fallback;
    }
  }

  function render(wrap, qty, isUnlocked) {
    var cfg     = readConfig(wrap);
    var target  = cfg.target_qty;
    qty         = Math.max(0, parseInt(qty, 10) || 0);
    var remain  = Math.max(0, target - qty);
    var pct     = Math.min(100, Math.round((qty / target) * 100));

    var fill = wrap.querySelector(SEL.fill);
    var msg  = wrap.querySelector(SEL.msg);

    if (fill) fill.style.width = pct + '%';

    if (isUnlocked && qty >= target) {
      wrap.classList.add('is-unlocked');
      if (msg) msg.innerHTML = cfg.unlocked;
    } else {
      wrap.classList.remove('is-unlocked');
      var template = (remain === 1 && cfg.almost) ? cfg.almost : cfg.pre;
      if (msg) msg.innerHTML = template.replace('{remaining}', remain);
    }
  }

  // BOGO4 eligibility: the automatic discount covers bands and cases only.
  // Accessories (the two glass protectors and the suction pad) must not
  // advance the bar or unlock it. Matched on product_id (rename-proof).
  var EXCLUDED_PIDS = {
    9311597723875: true,  // Phone Glass Screen Protector
    9311598936291: true,  // Privacy Phone Glass Screen Protector
    9311603851491: true,  // Silicone Suction Pad for Phone
    15447817158883: true  // Phone Glass Screen Protector - 2-Pack
  };

  function eligibleQty(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    cart.items.forEach(function (i) {
      if (!EXCLUDED_PIDS[i.product_id]) n += i.quantity || 0;
    });
    return n;
  }

  // The bar may only claim "unlocked" when a BOGO4 discount is genuinely
  // applied to a line in the cart.
  function hasBogo(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (i) {
      return (i.discounts || []).some(function (d) {
        return (d.title || '').toUpperCase().indexOf('BOGO4') !== -1;
      });
    });
  }

  function renderAll(cart) {
    var qty = eligibleQty(cart);
    var unlocked = hasBogo(cart);
    document.querySelectorAll(SEL.wrap).forEach(function (wrap) {
      render(wrap, qty, unlocked);
    });
  }

  function fetchAndRender() {
    window.fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderAll(cart); })
      .catch(function () { /* leave the Liquid default in place */ });
  }

  // Pipeline fires this on every cart mutation, with the full cart object.
  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) renderAll(cart);
    else fetchAndRender();
  });

  // Safety re-sync when the drawer opens (cart may have changed elsewhere).
  document.addEventListener('theme:drawer:open', fetchAndRender, true);

  // Initial paint.
  if (document.readyState !== 'loading') fetchAndRender();
  else document.addEventListener('DOMContentLoaded', fetchAndRender);
})();

/* ============================================================================
   AMP slide-cart SUPPRESSION  (preview / testing)
   Hides AMP's slidecarthq drawer and opens Pipeline's native drawer instead,
   so you can preview the coded cart while AMP is still installed.
   Safe to keep; does nothing once AMP no longer renders.
   ============================================================================ */
(function () {
  'use strict';

  function nativeDrawer() {
    return document.querySelector('[data-drawer="drawer-cart"]');
  }
  function openNative() {
    var d = nativeDrawer();
    if (d && !d.classList.contains('drawer--visible')) {
      d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }
  function neutralize() {
    var hq = document.getElementById('slidecarthq');
    if (!hq) return;
    hq.style.display = 'none';
    var ampOpen = !!hq.querySelector('.slidecarthq-overlay.open, .slidecarthq.open');
    hq.querySelectorAll('.open').forEach(function (el) { el.classList.remove('open'); });
    if (ampOpen) {
      // release AMP's scroll lock (only if it set it), then show our drawer
      ['html', 'body'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && el.style && el.style.overflow === 'hidden') el.style.overflow = '';
      });
      openNative();
    }
  }
  function start() {
    neutralize();
    try {
      new MutationObserver(neutralize).observe(document.documentElement, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* ============================================================================
   RELIABLE "open drawer on add"  (replaces AMP's flaky 600ms SLIDECART_OPEN)
   Opens Pipeline's native drawer whenever the cart item-count INCREASES,
   i.e. on a genuine add. Fires off Pipeline's own 'theme:cart:change' event,
   so it's deterministic and independent of AMP.
   ============================================================================ */
(function () {
  'use strict';
  var lastCount = null;
  function openNative() {
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d || d.classList.contains('drawer--visible')) return;
    d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    // FIRST open from an empty cart paints the cached empty state before the
    // just-added line item is fetched. Force Pipeline to reload the line items
    // once the drawer is open (twice, to win the race regardless of timing).
    setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); }, 150);
    setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); }, 600);
  }
  document.addEventListener('theme:cart:change', function (e) {
    var c = (e && e.detail && e.detail.cart) ? e.detail.cart.item_count : null;
    if (lastCount !== null && c !== null && c > lastCount) openNative();
    if (c !== null) lastCount = c;
  });
  // baseline so the very first add is recognised as an increase
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { if (lastCount === null) lastCount = c.item_count; })
    .catch(function () {});
})();

/* ============================================================================
   UPSELLS — toggle picker (swatches or dropdown), add via cart API, refresh
   ============================================================================ */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } })); })
      .catch(function () {});
  }
  function fbButton(item) { return item ? (item.querySelector('[data-sb-upsell-toggle]') || item.querySelector('.sb-upsell__add')) : null; }

  function addVariant(id, sourceEl) {
    if (!id) return;
    var item = sourceEl.closest('[data-sb-upsell]');
    var isSwatch = sourceEl.classList && sourceEl.classList.contains('sb-upsell__swatch');
    var fb = fbButton(item);
    var fbOriginal = fb ? fb.innerHTML : '';
    if (fb) fb.disabled = true;
    window.fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (isSwatch) sourceEl.classList.add('is-added');
        if (fb) { fb.innerHTML = 'Added \u2713'; fb.classList.add('is-added'); }
        if (item) {
          var tray = item.querySelector('[data-sb-upsell-variants]');
          if (tray) tray.hidden = true;
          var toggle = item.querySelector('[data-sb-upsell-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          var sel = item.querySelector('[data-sb-upsell-select]');
          if (sel) sel.value = '';
        }
        refreshCart();
        setTimeout(function () {
          if (fb) { fb.disabled = false; fb.innerHTML = fbOriginal; fb.classList.remove('is-added'); }
          if (isSwatch) sourceEl.classList.remove('is-added');
        }, 1600);
      })
      .catch(function () { if (fb) fb.disabled = false; });
  }

  // hide/show "hide-when-in-cart" upsells (e.g. grippy pad) based on cart contents
  function applyVisibility(cart) {
    var rows = document.querySelectorAll('[data-sb-upsell-hide-when-incart]');
    if (!rows.length) return;
    var ids = (cart && cart.items) ? cart.items.map(function (i) { return i.product_id; }) : [];
    rows.forEach(function (row) {
      var pid = Number(row.getAttribute('data-sb-upsell-pid'));
      row.hidden = ids.indexOf(pid) !== -1;
    });
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) {
      applyVisibility(e.detail.cart);
    } else {
      window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); }).then(applyVisibility).catch(function () {});
    }
  });
  // initial sync on load (also covers the case where it's already in the cart)
  window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); }).then(applyVisibility).catch(function () {});

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sb-upsell-toggle]');
    if (toggle) {
      var item = toggle.closest('[data-sb-upsell]');
      var tray = item && item.querySelector('[data-sb-upsell-variants]');
      if (tray) { var willOpen = tray.hidden; tray.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); }
      return;
    }
    var add = e.target.closest('[data-sb-upsell-add]');
    if (add) { e.preventDefault(); addVariant(add.getAttribute('data-sb-upsell-add'), add); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sb-upsell-select]');
    if (sel && sel.value) addVariant(sel.value, sel);
  });
})();

/* ============================================================================
   ROBUST backdrop close — tap the dimmed area to close the cart drawer.
   Pipeline's own underlay click can fail on mobile; this capture-phase handler
   targets the underlay element directly, so it works regardless. It only fires
   when the drawer is already open and the tap is on the underlay (never on the
   add-to-cart button), so it can't interfere with opening.
   ============================================================================ */
(function () {
  'use strict';
  function maybeClose(e) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"].drawer--visible');
    if (!drawer) return;                                   // closed -> ignore (also ignores the opening tap)
    var content = drawer.querySelector('.drawer__content'); // the panel: top + items + checkout footer
    if (content && e.target && content.contains(e.target)) return; // tap inside the panel -> keep open
    if (e.target && e.target.closest &&
        e.target.closest('[data-drawer-toggle],[data-cart-toggle],.product__submit__buttons,[data-add-to-cart],[name="add"]')) return;
    drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
  }
  document.addEventListener('click', maybeClose, true);
  document.addEventListener('touchend', maybeClose, true);
})();


/* ============================================================================
   UPSELL CONTEXT — makes "Complete your setup" context-aware:
     - widget hidden for empty or accessory-only carts
     - a case in the cart pre-matches protector rows to the case's iPhone model
       (one-tap add of the right variant instead of the model picker)
     - the watch-case row only appears when a band is in the cart
     - rows for products already in the cart stay hidden; max 3 rows shown
   ============================================================================ */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  var ROW_BY_PID = {
    15447817158883: 'pack',
    9311597723875: 'glass',
    9311598936291: 'privacy',
    7639025975523: 'watchcase',
    9311603851491: 'pad'
  };
  var mapsCache = null;
  function getMaps() {
    if (mapsCache) return mapsCache;
    var n = document.querySelector('[data-sb-upsell-maps]');
    if (!n) return null;
    try { mapsCache = JSON.parse(n.textContent); } catch (e) { mapsCache = null; }
    return mapsCache;
  }
  function analyze(cart) {
    var ctx = { count: 0, inCart: {}, hasCase: false, hasBand: false, models: {} };
    if (!cart || !cart.items) return ctx;
    ctx.count = cart.item_count || 0;
    cart.items.forEach(function (i) {
      ctx.inCart[i.product_id] = true;
      var ps = null;
      (i.options_with_values || []).forEach(function (o) { if (o.name === 'Phone Series') ps = o.value; });
      var isAcc = !!ROW_BY_PID[i.product_id];
      if (ps && !isAcc) { ctx.hasCase = true; ctx.models[ps] = true; }
      if (!ps && !isAcc) ctx.hasBand = true;
    });
    var keys = Object.keys(ctx.models);
    ctx.singleModel = keys.length === 1 ? keys[0] : null;
    return ctx;
  }
  function setMatched(row, vid, model) {
    var btn = row.querySelector('[data-sb-upsell-toggle], .sb-upsell__add');
    var label = row.querySelector('[data-sb-model-label]');
    if (!btn) return;
    if (vid) {
      if (!row.hasAttribute('data-sb-matched')) {
        row.setAttribute('data-sb-matched', '1');
        btn.setAttribute('data-sb-was-toggle', btn.hasAttribute('data-sb-upsell-toggle') ? '1' : '');
      }
      btn.removeAttribute('data-sb-upsell-toggle');
      btn.setAttribute('data-sb-upsell-add', String(vid));
      var tray = row.querySelector('[data-sb-upsell-variants]');
      if (tray) tray.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = ' \u2014 for ' + model;
    } else if (row.hasAttribute('data-sb-matched')) {
      row.removeAttribute('data-sb-matched');
      btn.removeAttribute('data-sb-upsell-add');
      if (btn.getAttribute('data-sb-was-toggle') === '1') btn.setAttribute('data-sb-upsell-toggle', '');
      btn.removeAttribute('data-sb-was-toggle');
      if (label) label.textContent = '';
    }
  }
  function apply(cart) {
    var wrap = document.querySelector('[data-sb-upsells]');
    if (!wrap) return;
    var ctx = analyze(cart);
    if (!ctx.count || (!ctx.hasCase && !ctx.hasBand)) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var maps = getMaps();
    var rows = {};
    wrap.querySelectorAll('[data-sb-row]').forEach(function (r) { rows[r.getAttribute('data-sb-row')] = r; });
    Object.keys(rows).forEach(function (k) {
      var pid = Number(rows[k].getAttribute('data-sb-upsell-pid'));
      rows[k].hidden = !!ctx.inCart[pid];
    });
    // if the 2-pack is in the cart, do not push the single on top of it
    if (rows.glass && ctx.inCart[15447817158883]) rows.glass.hidden = true;
    // the watch case is a band-context offer
    if (rows.watchcase && !ctx.hasBand) rows.watchcase.hidden = true;
    ['pack', 'glass', 'privacy'].forEach(function (k) {
      var row = rows[k];
      if (!row) return;
      var vid = null;
      if (ctx.singleModel && maps && maps[k]) vid = maps[k][ctx.singleModel] || null;
      setMatched(row, vid, ctx.singleModel);
    });
    var priority = ctx.hasCase
      ? ['pack', 'glass', 'privacy', 'watchcase', 'pad']
      : ['watchcase', 'glass', 'pack', 'privacy', 'pad'];
    var shown = 0;
    priority.forEach(function (k) {
      var row = rows[k];
      if (!row || row.hidden) return;
      shown += 1;
      if (shown > 3) row.hidden = true;
    });
    // physically reorder so the first visible row is the context's top offer
    priority.forEach(function (k) {
      var row = rows[k];
      if (row && !row.hidden && row.parentNode === wrap) wrap.appendChild(row);
    });
  }
  function sync() {
    window.fetch(root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) apply(e.detail.cart);
    else sync();
  });
  document.addEventListener('theme:drawer:open', sync, true);
  sync();
})();
